module.exports = __webpack_public_path__ + "img/other-login.fdc96e99.png";